import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { loginAuth } from "../Redux/Auth/action";

import "./Login.css";

function Login() {
  const signupData = JSON.parse(localStorage.getItem("signup")) || null;

  const dispatch=useDispatch();

  const navigate = useNavigate();

  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(formData);
    localStorage.setItem("login", JSON.stringify(formData));
    handleAuth(formData);
  };
  const handleAuth = (formData) => {
    if (formData.email === undefined && formData.pass === undefined) {
      alert("Please Give Proper Inputs");
    } else if (signupData !== null) {
      if (
        signupData.email === formData.email &&
        signupData.pass === formData.pass
      ) {
        alert("Login Succesfull");
        localStorage.setItem("auth", JSON.stringify(true));
        dispatch(loginAuth(true));
        navigate("/");
      }
    } else {
      alert("Validation Failed.wrong credential");
    }
  };

  return (
    <div id="container">
      <h1>Sign in</h1>
      <form onSubmit={handleSubmit}>
        <p>Email address :</p>
        <input
          id="email"
          type="email"
          placeholder="yourname@example.com"
          onChange={handleChange}
        />
        <p>Password:</p>
        <input
          id="pass"
          type="password"
          placeholder="Please enter your password"
          onChange={handleChange}
        />
        <br />
        <input id="btn" type="submit" value="Sign In" />
        <br />
        <h4>OR</h4>
        <br />
        <div
          id="button"
          onClick={() => {
            navigate("/signup");
          }}
        >
          Create your new account{" "}
        </div>
      </form>
    </div>
  );
}

export default Login;
